var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sfc-modal',{attrs:{"id":"sfc-onboarding-modal-v3-3","title":""}},[_c('h2',{staticClass:"title text-left"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('sfc-update-email')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }